import React from "react";
import CiroDropDown from "../../../shared/CiroDropdown";

interface IPastCuratedSearchSelector {
  historicalPrompts: string[];
  setSelectedPrompt: (prompt: string) => void;
}

const PastCuratedSearchSelector: React.FC<IPastCuratedSearchSelector> = ({
  historicalPrompts,
  setSelectedPrompt,
}) => {
  if (!historicalPrompts || historicalPrompts.length === 0) return null;

  const uniquePromptsByDescription = [...new Set(historicalPrompts)];

  if (uniquePromptsByDescription.length === 0) {
    return null;
  }

  return (
    <div className="flex items-center">
      <CiroDropDown
        isClearable={true}
        isMulti={false}
        options={uniquePromptsByDescription.map((p) => ({
          label: p,
          value: p,
        }))}
        onChange={(value) => {
          setSelectedPrompt(value || "");
        }}
        placeholder="Start from a previous search..."
        className="w-64"
      />
    </div>
  );
};

export default PastCuratedSearchSelector;
